import { render, staticRenderFns } from "./icp.vue?vue&type=template&id=6fec561c&scoped=true&"
import script from "./icp.vue?vue&type=script&lang=js&"
export * from "./icp.vue?vue&type=script&lang=js&"
import style0 from "./icp.vue?vue&type=style&index=0&id=6fec561c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fec561c",
  null
  
)

export default component.exports